import React from 'react';
import PropTypes from 'prop-types';

export default function Modal({ 
  children, 
  onClose, 
  title, 
  icon 
}) {
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '1rem'
  };

  const contentStyle = {
    background: '#fff',
    borderRadius: 8,
    maxWidth: '900px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
  };

  const headerStyle = {
        background: '#424242ff',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 1rem',
    borderBottom: '1px solid #eee'
  };

  const bodyStyle = {
    padding: '1rem'
  };

  return (
    <div className="modal-overlay" style={overlayStyle} onClick={onClose}>
      <div className="modal-content" style={contentStyle} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={headerStyle}>
          <h5 style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
            {icon && <i className={`bi ${icon} me-2`} style={{ marginRight: 8 }}></i>}
            {title}
          </h5>
          <button className="btn-close btn-close-white" onClick={onClose} aria-label="Chiudi"></button>
        </div>
        <div className="modal-body" style={bodyStyle}>
          {children}
        </div>
      </div>
    </div>
  );
}

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};
